export default __webpack_public_path__ + "static/media/qr-error.568ea796.png";